import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center">
      <div>
        <p className="text-sm uppercase tracking-wider text-slate-400">404</p>
        <h1 className="text-2xl font-semibold mt-2">Page not found</h1>
        <p className="text-slate-500 mt-2 max-w-sm">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block mt-6 text-sm font-medium text-brand-600 hover:text-brand-700"
        >
          ← Back home
        </Link>
      </div>
    </div>
  );
}
